import { formatDateTime24h } from './dateHelper';

const buildFileNameWithDate = (fileName: string, format: string, joinString?: boolean): string => {
  const newDate = new Date(Date.now()).toISOString();
  return `${fileName}${joinString ? '_' : ' '}${formatDateTime24h(newDate)}.${format}`;
};

export default buildFileNameWithDate;
